'use client';

import { createContext, useContext } from 'react';

export type EvidenceLockerAppearance = 'default' | 'inverse';

export const EvidenceLockerAppearanceContext =
  createContext<EvidenceLockerAppearance>('default');

export function useEvidenceLockerAppearance(): EvidenceLockerAppearance {
  return useContext(EvidenceLockerAppearanceContext);
}
